export default (props, vars) =>
  vars?.['usestateprofilepopupopened']?.['state'] !== undefined;
